import {
  SHTable,
  SHTableBody,
  SHTableCell,
  SHTableContainer,
  SHTableHead,
  SHTableRow,
} from "@components/design-systems";
import SHSkeleton from "@components/design-systems/sh-skeleton";
import { useTheme } from "@mui/material";
import { hexToRGBA } from "@utils";
const ROWS = 10;
const COLS = 8;
export const ModelScreenerTableSkeleton = () => {
  const { palette } = useTheme();
  return (
    <SHTableContainer>
      <SHTable>
        <SHTableHead>
          <SHTableRow
            sx={{
              backgroundColor: `${hexToRGBA(
                palette.secondary[100],
                0.2,
              )} !important`,
            }}
          >
            <SHTableCell
              colSpan={4}
              sx={{
                padding: "0 16px !important",
                height: 25,
                borderRight: `1px solid ${palette.divider}`,
              }}
            >
              <SHSkeleton
                delay={false}
                variant="text"
                width={100}
                height={20}
              />
            </SHTableCell>

            <SHTableCell
              colSpan={2}
              sx={{
                padding: "0 16px !important",
                height: 25,
                borderRight: `1px solid ${palette.divider}`,
              }}
            >
              <SHSkeleton
                delay={false}
                variant="text"
                width={100}
                height={20}
              />
            </SHTableCell>
            <SHTableCell
              colSpan={2}
              sx={{
                padding: "0 16px !important",
                height: 25,
                borderRight: `1px solid ${palette.divider}`,
              }}
            >
              <SHSkeleton
                delay={false}
                variant="text"
                width={100}
                height={20}
              />
            </SHTableCell>
          </SHTableRow>
          <SHTableRow>
            <SHTableCell
              sx={{
                padding: "0 16px !important",
                height: 42,
                borderRight: `1px solid ${palette.divider}`,
              }}
            >
              <SHSkeleton
                delay={false}
                variant="text"
                width={100}
                height={20}
              />
            </SHTableCell>
            <SHTableCell
              sx={{
                padding: "0 16px !important",
                height: 42,
                borderRight: `1px solid ${palette.divider}`,
              }}
            >
              <SHSkeleton
                delay={false}
                variant="text"
                width={100}
                height={20}
              />
            </SHTableCell>

            <SHTableCell
              sx={{
                padding: "0 16px !important",
                height: 42,
                borderRight: `1px solid ${palette.divider}`,
              }}
            >
              <SHSkeleton
                delay={false}
                variant="text"
                width={100}
                height={20}
              />
            </SHTableCell>
            <SHTableCell
              sx={{
                padding: "0 16px !important",
                height: 42,
                borderRight: `1px solid ${palette.divider}`,
              }}
            >
              <SHSkeleton
                delay={false}
                variant="text"
                width={100}
                height={20}
              />
            </SHTableCell>
            <SHTableCell
              sx={{
                padding: "0 16px !important",
                height: 42,
                borderRight: `1px solid ${palette.divider}`,
              }}
            >
              <SHSkeleton
                delay={false}
                variant="text"
                width={100}
                height={20}
              />
            </SHTableCell>
            <SHTableCell
              sx={{
                padding: "0 16px !important",
                height: 42,
                borderRight: `1px solid ${palette.divider}`,
              }}
            >
              <SHSkeleton
                delay={false}
                variant="text"
                width={100}
                height={20}
              />
            </SHTableCell>
            <SHTableCell
              sx={{
                padding: "0 16px !important",
                height: 42,
                borderRight: `1px solid ${palette.divider}`,
              }}
            >
              <SHSkeleton
                delay={false}
                variant="text"
                width={100}
                height={20}
              />
            </SHTableCell>
            <SHTableCell
              sx={{
                padding: "0 16px !important",
                height: 42,
                borderRight: `1px solid ${palette.divider}`,
              }}
            >
              <SHSkeleton
                delay={false}
                variant="text"
                width={100}
                height={20}
              />
            </SHTableCell>
          </SHTableRow>
        </SHTableHead>
        <SHTableBody>
          {[...Array(ROWS)].map((_, rowIndex) => (
            <SHTableRow
              sx={{
                backgroundColor:
                  rowIndex % 2 === 0
                    ? `${palette.secondary[50]} !important`
                    : "white !important",
              }}
              key={rowIndex}
            >
              {[...Array(COLS)].map((_, colIndex) => (
                <SHTableCell key={colIndex}>
                  <SHSkeleton
                    delay={false}
                    variant="text"
                    width="100%"
                    height={25}
                  />
                </SHTableCell>
              ))}
            </SHTableRow>
          ))}
        </SHTableBody>
      </SHTable>
    </SHTableContainer>
  );
};
